// extracted by mini-css-extract-plugin
export default {"select":"LanguageSelect_select__NJaNu"};